import React, { useEffect, useRef, useState } from "react";
import { getImageUrl, getVideoUrl, getVideoInfo, getInstagramUrl } from "../services/api";
import "./Extra.css";

const Extra = () => {
  const [bannerUrl, setBannerUrl] = useState("");
  const [videoExists, setVideoExists] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);
  const [audioExists, setAudioExists] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const [instagramUrl, setInstagramUrl] = useState("");
  const [downloadCooldown, setDownloadCooldown] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    setBannerUrl(getImageUrl("extra-banner"));

    getVideoInfo("extra-video")
      .then((res) => setVideoExists(res.data.exists))
      .catch(() => setVideoExists(false))
      .finally(() => setVideoLoading(false));

    getVideoInfo("extra-audio")
      .then((res) => setAudioExists(res.data.exists))
      .catch(() => setAudioExists(false));

    getInstagramUrl()
      .then((res) => setInstagramUrl(res.data.instagramUrl || ""))
      .catch(() => setInstagramUrl(""));
  }, []);

  const handleBadgeClick = () => {
    if (!instagramUrl) return;
    if (videoRef.current) videoRef.current.pause();
    window.open(instagramUrl, "_blank", "noopener,noreferrer");
  };

  const handleOverlayClick = () => {
    if (!instagramUrl) return;
    window.open(instagramUrl, "_blank", "noopener,noreferrer");
  };

  const handleMp3Download = () => {
    if (downloadCooldown) return;
    const link = document.createElement("a");
    link.href = getVideoUrl("extra-audio", true);
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setDownloadCooldown(true);
    setTimeout(() => setDownloadCooldown(false), 10000);
  };

  return (
    <div className="extra-page">
      <section
        className="extra-hero"
        style={{
          backgroundImage: bannerUrl ? `url(${bannerUrl})` : "none",
        }}
      >
        <h1>Extra</h1>
        <p>Contenu exclusif</p>
      </section>

      <div className="container">
        <section className="extra-content">
          <h2>J'aurais pu faire mieux - Personal Regrets</h2>

          <div className="video-wrapper">
            {videoLoading ? (
              <div className="video-placeholder">
                <div className="video-spinner"></div>
              </div>
            ) : videoExists ? (
              <div className="video-container">
                <video
                  ref={videoRef}
                  className="extra-video"
                  controls
                  preload="metadata"
                  src={getVideoUrl("extra-video")}
                  onPlay={() => setHasEnded(false)}
                  onEnded={() => setHasEnded(true)}
                >
                  Votre navigateur ne supporte pas la lecture vidéo HTML5.
                </video>

                {/* Badge permanent haut droite — masqué si pas de lien configuré */}
                {instagramUrl && (
                <button
                  className="instagram-badge"
                  onClick={handleBadgeClick}
                  aria-label="Voir sur Instagram"
                >
                  <svg viewBox="0 0 24 24" fill="white" width="18" height="18">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                  <span>Instagram</span>
                </button>
                )}

                {/* Overlay fin de vidéo */}
                {hasEnded && instagramUrl && (
                  <div
                    className="instagram-overlay"
                    onClick={handleOverlayClick}
                    role="button"
                    aria-label="Voir sur Instagram"
                  >
                    <div className="instagram-overlay-content">
                      <svg viewBox="0 0 24 24" fill="white" width="40" height="40">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                      <p>Clique pour voir le clip en entier</p>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="video-placeholder">
                <span>🎬</span>
                <p>Vidéo à venir</p>
              </div>
            )}
          </div>

          {audioExists && (
            <div className="audio-download">
              <button
                className={`download-btn${downloadCooldown ? " download-btn--cooldown" : ""}`}
                onClick={handleMp3Download}
                disabled={downloadCooldown}
              >
                {downloadCooldown ? "✅ Téléchargement en cours..." : "⬇️ Télécharger en MP3"}
              </button>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Extra;

